export const defaultColumns = [
  {
    groupName: "integrated_drive",
    columns: [
      // "PRODUCT_CODE",
      // "T_COMMUNICATION_INTERFACE",
      // "TC_VOLTAGE",
      // "T_OFFER_TYPE",
      // "T_ENCODER_TYPE",
      // "T_NUMBER_OF_MOTOR_STACKS",
      // "T_SHAFT_TYPE",
      // "T_MOTOR_FLANGE_SIZE",
      // "T_HOLDING_BRAKE"
    ],
    deploy: true
  },
  {
    groupName: "gearbox",
    columns: [
      "gearboxReference",
      "gearboxComponentType",
      "gearboxType",
      "gearboxFamily", // Device short name
      "externalDiameter",
      "inputDiameter",
      "gearboxRatio",
      "gearboxEfficiency",
      "gearboxTorsionalBacklash",
      "shaftMomentOfInertia",
      "gearboxNetWeight",
      "gearboxLength"
    ],
    deploy: false
  },
  {
    groupName: "accessories",
    columns: ["adaptationKitRef", "adaptationKitComponentType", "separatePartDestination", "adaptationKitLength"]
  }
];

// Personnalize columns
export const choosableColumns = [
  // Bundle columns
  "PRODUCT_CODE",
  "T_COMMUNICATION_INTERFACE",
  "TC_VOLTAGE",
  "T_OFFER_TYPE",
  "T_ENCODER_TYPE",
  "T_NUMBER_OF_MOTOR_STACKS",
  "T_SHAFT_TYPE",
  "T_MOTOR_FLANGE_SIZE",
  "T_HOLDING_BRAKE",

  // Gearbox columns
  "gearboxReference",
  "gearboxComponentType",
  "gearboxType",
  "gearboxFamily", // Device short name
  "externalDiameter",
  "inputDiameter",
  "gearboxRatio",
  "gearboxEfficiency",
  "gearboxTorsionalBacklash",
  "shaftMomentOfInertia",
  "gearboxNetWeight",
  "gearboxLength",
  "continuousOutputTorque",
  "maximumOutputTorque",
  "gearboxIpDegreeOfProtection",

  // Adaptation kit columns
  "adaptationKitRef",
  "adaptationKitComponentType",
  "separatePartDestination",
  "adaptationKitLength"
].sort();

export const tmpIntegratedDrivesFilters = {
  locale: "en-WW",
  paging: {
    skip: 0,
    limit: 50
  },
  search: {
    gearboxFilter: {
      enabled: true,
      reductionRatio: [],
      productOrComponentType: ["PLANETARY_GEARBOX"],
      torsionalBacklash: {
        min: 0,
        max: 60
      },
      externalDiameter: []
    },
    integratedDriveFilter: {
      MOTOR_TYPE: "STEPPER",
      T_COMMUNICATION_INTERFACE: ["PROFINET"],
      TC_VOLTAGE: ["48V"],
      T_OFFER_TYPE: ["ADVANCED"],
      T_ENCODER_TYPE: ["ABSOLUTE_MULTI_TURN_18_BIT"],
      T_NUMBER_OF_MOTOR_STACKS: ["2_STACKS"],
      T_SHAFT_TYPE: ["SMOOTH_SHAFT_WITHOUT_SHAFT_00"],
      T_MOTOR_FLANGE_SIZE: ["85MM"],
      T_HOLDING_BRAKE: ["WITHOUT_HOLDING_BRAKE"]
    }
  }
};

export const BUNDLES_EXAMPLE = [
  {
    id: 721100,
    motor: {
      commercialReference: "BMH0701P06A2A",
      type: "BMH",
      flangeSize: 70,
      inertiaMotor: 0.59,
      shaftDiameter: 11,
      shaftEnd: "SMOOTH_SHAFT",
      brake: false,
      length: 122,
      encoder: "SINGLE_TURN_SINCOS_HIPERFACE",
      connector: "ROTATABLE_RIGHT-ANGLED_CONNS",
      shaftLength: "23.0",
      nominalTorques: [
        "1.1 N.m for LXM32.U60N4 at 1.5 A, 400 V, three phase",
        "1.1 N.m for LXM32.U60N4 at 1.5 A, 480 V, three phase",
        "1.3 N.m for LXM32.D12N4 at 3 A, 400 V, three phase",
        "1.3 N.m for LXM32.D12N4 at 3 A, 480 V, three phase"
      ],
      nominalSpeeds: [
        "3000 rpm for LXM32.U60N4 at 1.5 A, 400 V, three phase",
        "3000 rpm for LXM32.U60N4 at 1.5 A, 480 V, three phase",
        "5000 rpm for LXM32.D12N4 at 3 A, 400 V, three phase",
        "5000 rpm for LXM32.D12N4 at 3 A, 480 V, three phase"
      ],
      ipProtections: ["IP54 standard"],
      ipProtectionsAsString: "",
      peakStallTorque: 4.2,
      continuousStallTorque: 1.2,
      componentType: "servo motor",
      numberOfStacks: "1.0",
      maximumMechanicalSpeed: 8000,
      productWeight: 1.6,
      continuousStallCurrent: 1.78,
      speedFeedbackResolution: "32768 points/turn",
      description: "servo motor BMH, Lexium 32, 1.2Nm, 8000rpm, untapped shaft, without brake, IP54, 16bit encoder",
      motorSpecificAttributesList: [
        {
          id: 12952,
          nominalTorque: 1.1,
          nominalSpeed: 3000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 1.5,
          supplyVoltage: 400
        },
        {
          id: 12953,
          nominalTorque: 1.1,
          nominalSpeed: 3000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 1.5,
          supplyVoltage: 480
        },
        {
          id: 12954,
          nominalTorque: 1.3,
          nominalSpeed: 5000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 3,
          supplyVoltage: 400
        },
        {
          id: 12955,
          nominalTorque: 1.3,
          nominalSpeed: 5000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 3,
          supplyVoltage: 480
        }
      ],
      ipProtectionAssociations: [
        {
          id: 7469,
          ipProtection: "IP54",
          conditionOfUse: "STANDARD"
        }
      ]
    },
    drive: {
      commercialReference: "LXM32AD18M2",
      type: "LXM32A",
      outputCurrents: ["6 A at 8 kHz"],
      outputCurrentsAsString: "",
      outputVoltages: ["100...120 V - 15...10 %", "200...240 V - 15...10 %"],
      outputVoltagesAsString: "",
      communicationInterfaces: ["CANmotion, integrated", "CANopen, integrated", "Modbus, integrated"],
      communicationInterfacesAsString: "",
      format: "BOOK",
      nbPhases: ["SINGLE_PHASE"],
      nbPhasesAsString: "",
      switchingFreq: 8,
      nominalPower: 0.5,
      componentType: "motion servo drive",
      width: 48,
      rangeOfProduct: "Lexium 32",
      lineCurrent: 9.9,
      height: 270,
      depth: 237,
      netWeight: 1.8,
      description: "motion servo drive, Lexium 32, 18A, single phase, supply voltage 115 to 230V, 0.5 to 1kW, IP20",
      bundles: [],
      driveVoltages: [
        {
          id: 193,
          outputVoltageMin: 100,
          outputVoltageMax: 120,
          outputVoltageMinMax: "100..120",
          toleranceMin: -15,
          toleranceMax: 10,
          nbPhases: "SINGLE_PHASE"
        },
        {
          id: 194,
          outputVoltageMin: 200,
          outputVoltageMax: 240,
          outputVoltageMinMax: "200..240",
          toleranceMin: -15,
          toleranceMax: 10,
          nbPhases: "SINGLE_PHASE"
        }
      ],
      driveCommunicationInterfaces: [
        {
          id: 189,
          communicationInterface: "CANMOTION",
          conditionOfUse: "INTEGRATED"
        },
        {
          id: 190,
          communicationInterface: "CANOPEN",
          conditionOfUse: "INTEGRATED"
        },
        {
          id: 191,
          communicationInterface: "MODBUS",
          conditionOfUse: "INTEGRATED"
        }
      ],
      driveOutputCurrents: [
        {
          id: 105,
          current: 6,
          frequency: 8
        }
      ]
    },
    gearbox: {
      commercialReference: "GBX060003K",
      family: "GBX",
      productOrComponentType: "PLANETARY_GEARBOX",
      type: "STRAIGHT_TEETH",
      efficiency: 96,
      reductionRatio: 3,
      maximumOutputTorque: 45,
      continuousOutputTorque: 28,
      shaftMomentOfInertia: 0.135,
      inputDiameter: 14,
      torsionalBacklash: 10,
      gearboxLength: 39,
      externalDiameter: 60,
      productWeight: 0.9,
      ipDegreeOfProtection: "IP54",
      description: "gearbox straight teeth GBX, Lexium, 60mm, reduction 3:1 , 10arc.min, 28N.m",
      bundles: []
    },
    adaptationKitRef: "GBK0600702F",
    adaptationKit: {
      commercialReference: "GBK0600702F",
      flangeSize: 70,
      weight: 0.2,
      compatibility: "LEXIUM_62_ILM",
      externalDiameter: 60,
      componentType: "adaptation kit",
      length: 16.1,
      accessoryDestination: "for assembly motor and gearbox",
      kitComposition: ["screws and bolts for mounting", "an adaptor plate", "a shaft end adaptor"],
      description: "adaptation kit, Lexium, GBK, size 60, 16mm, for assembly motor and gearbox",
      bundles: []
    },
    inertia: 6.5249999999999995,
    length: 177.1,
    supplyVoltage: 480,
    continuousOutputCurrent: 3,
    nominalTorque: 3.7439999999999998,
    nominalSpeed: 1666.6666666666667,
    nominalTorqueOfMotor: 1.3,
    nominalSpeedOfMotor: 5000
  },
  {
    id: 721101,
    motor: {
      commercialReference: "BMH0701P06A2A",
      type: "BMH",
      flangeSize: 70,
      inertiaMotor: 0.59,
      shaftDiameter: 11,
      shaftEnd: "SMOOTH_SHAFT",
      brake: false,
      length: 122,
      encoder: "SINGLE_TURN_SINCOS_HIPERFACE",
      connector: "ROTATABLE_RIGHT-ANGLED_CONNS",
      shaftLength: "23.0",
      nominalTorques: [
        "1.1 N.m for LXM32.U60N4 at 1.5 A, 400 V, three phase",
        "1.1 N.m for LXM32.U60N4 at 1.5 A, 480 V, three phase",
        "1.3 N.m for LXM32.D12N4 at 3 A, 400 V, three phase",
        "1.3 N.m for LXM32.D12N4 at 3 A, 480 V, three phase"
      ],
      nominalSpeeds: [
        "3000 rpm for LXM32.U60N4 at 1.5 A, 400 V, three phase",
        "3000 rpm for LXM32.U60N4 at 1.5 A, 480 V, three phase",
        "5000 rpm for LXM32.D12N4 at 3 A, 400 V, three phase",
        "5000 rpm for LXM32.D12N4 at 3 A, 480 V, three phase"
      ],
      ipProtections: ["IP54 standard"],
      ipProtectionsAsString: "",
      peakStallTorque: 4.2,
      continuousStallTorque: 1.2,
      componentType: "servo motor",
      numberOfStacks: "1.0",
      maximumMechanicalSpeed: 8000,
      productWeight: 1.6,
      continuousStallCurrent: 1.78,
      speedFeedbackResolution: "32768 points/turn",
      description: "servo motor BMH, Lexium 32, 1.2Nm, 8000rpm, untapped shaft, without brake, IP54, 16bit encoder",
      motorSpecificAttributesList: [
        {
          id: 12952,
          nominalTorque: 1.1,
          nominalSpeed: 3000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 1.5,
          supplyVoltage: 400
        },
        {
          id: 12953,
          nominalTorque: 1.1,
          nominalSpeed: 3000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 1.5,
          supplyVoltage: 480
        },
        {
          id: 12954,
          nominalTorque: 1.3,
          nominalSpeed: 5000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 3,
          supplyVoltage: 400
        },
        {
          id: 12955,
          nominalTorque: 1.3,
          nominalSpeed: 5000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 3,
          supplyVoltage: 480
        }
      ],
      ipProtectionAssociations: [
        {
          id: 7469,
          ipProtection: "IP54",
          conditionOfUse: "STANDARD"
        }
      ]
    },
    drive: {
      commercialReference: "LXM32AD18M2",
      type: "LXM32A",
      outputCurrents: ["6 A at 8 kHz"],
      outputCurrentsAsString: "",
      outputVoltages: ["100...120 V - 15...10 %", "200...240 V - 15...10 %"],
      outputVoltagesAsString: "",
      communicationInterfaces: ["CANmotion, integrated", "CANopen, integrated", "Modbus, integrated"],
      communicationInterfacesAsString: "",
      format: "BOOK",
      nbPhases: ["SINGLE_PHASE"],
      nbPhasesAsString: "",
      switchingFreq: 8,
      nominalPower: 0.5,
      componentType: "motion servo drive",
      width: 48,
      rangeOfProduct: "Lexium 32",
      lineCurrent: 9.9,
      height: 270,
      depth: 237,
      netWeight: 1.8,
      description: "motion servo drive, Lexium 32, 18A, single phase, supply voltage 115 to 230V, 0.5 to 1kW, IP20",
      bundles: [],
      driveVoltages: [
        {
          id: 193,
          outputVoltageMin: 100,
          outputVoltageMax: 120,
          outputVoltageMinMax: "100..120",
          toleranceMin: -15,
          toleranceMax: 10,
          nbPhases: "SINGLE_PHASE"
        },
        {
          id: 194,
          outputVoltageMin: 200,
          outputVoltageMax: 240,
          outputVoltageMinMax: "200..240",
          toleranceMin: -15,
          toleranceMax: 10,
          nbPhases: "SINGLE_PHASE"
        }
      ],
      driveCommunicationInterfaces: [
        {
          id: 189,
          communicationInterface: "CANMOTION",
          conditionOfUse: "INTEGRATED"
        },
        {
          id: 190,
          communicationInterface: "CANOPEN",
          conditionOfUse: "INTEGRATED"
        },
        {
          id: 191,
          communicationInterface: "MODBUS",
          conditionOfUse: "INTEGRATED"
        }
      ],
      driveOutputCurrents: [
        {
          id: 105,
          current: 6,
          frequency: 8
        }
      ]
    },
    gearbox: {
      commercialReference: "GBX060003K",
      family: "GBX",
      productOrComponentType: "PLANETARY_GEARBOX",
      type: "STRAIGHT_TEETH",
      efficiency: 96,
      reductionRatio: 3,
      maximumOutputTorque: 45,
      continuousOutputTorque: 28,
      shaftMomentOfInertia: 0.135,
      inputDiameter: 14,
      torsionalBacklash: 10,
      gearboxLength: 39,
      externalDiameter: 60,
      productWeight: 0.9,
      ipDegreeOfProtection: "IP54",
      description: "gearbox straight teeth GBX, Lexium, 60mm, reduction 3:1 , 10arc.min, 28N.m",
      bundles: []
    },
    adaptationKitRef: "GBK0600702F",
    adaptationKit: {
      commercialReference: "GBK0600702F",
      flangeSize: 70,
      weight: 0.2,
      compatibility: "LEXIUM_62_ILM",
      externalDiameter: 60,
      componentType: "adaptation kit",
      length: 16.1,
      accessoryDestination: "for assembly motor and gearbox",
      kitComposition: ["screws and bolts for mounting", "an adaptor plate", "a shaft end adaptor"],
      description: "adaptation kit, Lexium, GBK, size 60, 16mm, for assembly motor and gearbox",
      bundles: []
    },
    inertia: 6.5249999999999995,
    length: 177.1,
    supplyVoltage: 480,
    continuousOutputCurrent: 3,
    nominalTorque: 3.7439999999999998,
    nominalSpeed: 1666.6666666666667,
    nominalTorqueOfMotor: 1.3,
    nominalSpeedOfMotor: 5000
  },
  {
    id: 721101,
    motor: {
      commercialReference: "BMH0701P06A2A",
      type: "BMH",
      flangeSize: 70,
      inertiaMotor: 0.59,
      shaftDiameter: 11,
      shaftEnd: "SMOOTH_SHAFT",
      brake: false,
      length: 122,
      encoder: "SINGLE_TURN_SINCOS_HIPERFACE",
      connector: "ROTATABLE_RIGHT-ANGLED_CONNS",
      shaftLength: "23.0",
      nominalTorques: [
        "1.1 N.m for LXM32.U60N4 at 1.5 A, 400 V, three phase",
        "1.1 N.m for LXM32.U60N4 at 1.5 A, 480 V, three phase",
        "1.3 N.m for LXM32.D12N4 at 3 A, 400 V, three phase",
        "1.3 N.m for LXM32.D12N4 at 3 A, 480 V, three phase"
      ],
      nominalSpeeds: [
        "3000 rpm for LXM32.U60N4 at 1.5 A, 400 V, three phase",
        "3000 rpm for LXM32.U60N4 at 1.5 A, 480 V, three phase",
        "5000 rpm for LXM32.D12N4 at 3 A, 400 V, three phase",
        "5000 rpm for LXM32.D12N4 at 3 A, 480 V, three phase"
      ],
      ipProtections: ["IP54 standard"],
      ipProtectionsAsString: "",
      peakStallTorque: 4.2,
      continuousStallTorque: 1.2,
      componentType: "servo motor",
      numberOfStacks: "1.0",
      maximumMechanicalSpeed: 8000,
      productWeight: 1.6,
      continuousStallCurrent: 1.78,
      speedFeedbackResolution: "32768 points/turn",
      description: "servo motor BMH, Lexium 32, 1.2Nm, 8000rpm, untapped shaft, without brake, IP54, 16bit encoder",
      motorSpecificAttributesList: [
        {
          id: 12952,
          nominalTorque: 1.1,
          nominalSpeed: 3000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 1.5,
          supplyVoltage: 400
        },
        {
          id: 12953,
          nominalTorque: 1.1,
          nominalSpeed: 3000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 1.5,
          supplyVoltage: 480
        },
        {
          id: 12954,
          nominalTorque: 1.3,
          nominalSpeed: 5000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 3,
          supplyVoltage: 400
        },
        {
          id: 12955,
          nominalTorque: 1.3,
          nominalSpeed: 5000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 3,
          supplyVoltage: 480
        }
      ],
      ipProtectionAssociations: [
        {
          id: 7469,
          ipProtection: "IP54",
          conditionOfUse: "STANDARD"
        }
      ]
    },
    drive: {
      commercialReference: "LXM32AD18M2",
      type: "LXM32A",
      outputCurrents: ["6 A at 8 kHz"],
      outputCurrentsAsString: "",
      outputVoltages: ["100...120 V - 15...10 %", "200...240 V - 15...10 %"],
      outputVoltagesAsString: "",
      communicationInterfaces: ["CANmotion, integrated", "CANopen, integrated", "Modbus, integrated"],
      communicationInterfacesAsString: "",
      format: "BOOK",
      nbPhases: ["SINGLE_PHASE"],
      nbPhasesAsString: "",
      switchingFreq: 8,
      nominalPower: 0.5,
      componentType: "motion servo drive",
      width: 48,
      rangeOfProduct: "Lexium 32",
      lineCurrent: 9.9,
      height: 270,
      depth: 237,
      netWeight: 1.8,
      description: "motion servo drive, Lexium 32, 18A, single phase, supply voltage 115 to 230V, 0.5 to 1kW, IP20",
      bundles: [],
      driveVoltages: [
        {
          id: 193,
          outputVoltageMin: 100,
          outputVoltageMax: 120,
          outputVoltageMinMax: "100..120",
          toleranceMin: -15,
          toleranceMax: 10,
          nbPhases: "SINGLE_PHASE"
        },
        {
          id: 194,
          outputVoltageMin: 200,
          outputVoltageMax: 240,
          outputVoltageMinMax: "200..240",
          toleranceMin: -15,
          toleranceMax: 10,
          nbPhases: "SINGLE_PHASE"
        }
      ],
      driveCommunicationInterfaces: [
        {
          id: 189,
          communicationInterface: "CANMOTION",
          conditionOfUse: "INTEGRATED"
        },
        {
          id: 190,
          communicationInterface: "CANOPEN",
          conditionOfUse: "INTEGRATED"
        },
        {
          id: 191,
          communicationInterface: "MODBUS",
          conditionOfUse: "INTEGRATED"
        }
      ],
      driveOutputCurrents: [
        {
          id: 105,
          current: 6,
          frequency: 8
        }
      ]
    },
    gearbox: {
      commercialReference: "GBX060003K",
      family: "GBX",
      productOrComponentType: "PLANETARY_GEARBOX",
      type: "STRAIGHT_TEETH",
      efficiency: 96,
      reductionRatio: 3,
      maximumOutputTorque: 45,
      continuousOutputTorque: 28,
      shaftMomentOfInertia: 0.135,
      inputDiameter: 14,
      torsionalBacklash: 10,
      gearboxLength: 39,
      externalDiameter: 60,
      productWeight: 0.9,
      ipDegreeOfProtection: "IP54",
      description: "gearbox straight teeth GBX, Lexium, 60mm, reduction 3:1 , 10arc.min, 28N.m",
      bundles: []
    },
    adaptationKitRef: "GBK0600702F",
    adaptationKit: {
      commercialReference: "GBK0600702F",
      flangeSize: 70,
      weight: 0.2,
      compatibility: "LEXIUM_62_ILM",
      externalDiameter: 60,
      componentType: "adaptation kit",
      length: 16.1,
      accessoryDestination: "for assembly motor and gearbox",
      kitComposition: ["screws and bolts for mounting", "an adaptor plate", "a shaft end adaptor"],
      description: "adaptation kit, Lexium, GBK, size 60, 16mm, for assembly motor and gearbox",
      bundles: []
    },
    inertia: 6.5249999999999995,
    length: 177.1,
    supplyVoltage: 480,
    continuousOutputCurrent: 3,
    nominalTorque: 3.7439999999999998,
    nominalSpeed: 1666.6666666666667,
    nominalTorqueOfMotor: 1.3,
    nominalSpeedOfMotor: 5000
  },
  {
    id: 721101,
    motor: {
      commercialReference: "BMH0701P06A2A",
      type: "BMH",
      flangeSize: 70,
      inertiaMotor: 0.59,
      shaftDiameter: 11,
      shaftEnd: "SMOOTH_SHAFT",
      brake: false,
      length: 122,
      encoder: "SINGLE_TURN_SINCOS_HIPERFACE",
      connector: "ROTATABLE_RIGHT-ANGLED_CONNS",
      shaftLength: "23.0",
      nominalTorques: [
        "1.1 N.m for LXM32.U60N4 at 1.5 A, 400 V, three phase",
        "1.1 N.m for LXM32.U60N4 at 1.5 A, 480 V, three phase",
        "1.3 N.m for LXM32.D12N4 at 3 A, 400 V, three phase",
        "1.3 N.m for LXM32.D12N4 at 3 A, 480 V, three phase"
      ],
      nominalSpeeds: [
        "3000 rpm for LXM32.U60N4 at 1.5 A, 400 V, three phase",
        "3000 rpm for LXM32.U60N4 at 1.5 A, 480 V, three phase",
        "5000 rpm for LXM32.D12N4 at 3 A, 400 V, three phase",
        "5000 rpm for LXM32.D12N4 at 3 A, 480 V, three phase"
      ],
      ipProtections: ["IP54 standard"],
      ipProtectionsAsString: "",
      peakStallTorque: 4.2,
      continuousStallTorque: 1.2,
      componentType: "servo motor",
      numberOfStacks: "1.0",
      maximumMechanicalSpeed: 8000,
      productWeight: 1.6,
      continuousStallCurrent: 1.78,
      speedFeedbackResolution: "32768 points/turn",
      description: "servo motor BMH, Lexium 32, 1.2Nm, 8000rpm, untapped shaft, without brake, IP54, 16bit encoder",
      motorSpecificAttributesList: [
        {
          id: 12952,
          nominalTorque: 1.1,
          nominalSpeed: 3000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 1.5,
          supplyVoltage: 400
        },
        {
          id: 12953,
          nominalTorque: 1.1,
          nominalSpeed: 3000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 1.5,
          supplyVoltage: 480
        },
        {
          id: 12954,
          nominalTorque: 1.3,
          nominalSpeed: 5000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 3,
          supplyVoltage: 400
        },
        {
          id: 12955,
          nominalTorque: 1.3,
          nominalSpeed: 5000,
          nbPhases: "THREE_PHASE",
          inputCurrent: 3,
          supplyVoltage: 480
        }
      ],
      ipProtectionAssociations: [
        {
          id: 7469,
          ipProtection: "IP54",
          conditionOfUse: "STANDARD"
        }
      ]
    },
    drive: {
      commercialReference: "LXM32AD18M2",
      type: "LXM32A",
      outputCurrents: ["6 A at 8 kHz"],
      outputCurrentsAsString: "",
      outputVoltages: ["100...120 V - 15...10 %", "200...240 V - 15...10 %"],
      outputVoltagesAsString: "",
      communicationInterfaces: ["CANmotion, integrated", "CANopen, integrated", "Modbus, integrated"],
      communicationInterfacesAsString: "",
      format: "BOOK",
      nbPhases: ["SINGLE_PHASE"],
      nbPhasesAsString: "",
      switchingFreq: 8,
      nominalPower: 0.5,
      componentType: "motion servo drive",
      width: 48,
      rangeOfProduct: "Lexium 32",
      lineCurrent: 9.9,
      height: 270,
      depth: 237,
      netWeight: 1.8,
      description: "motion servo drive, Lexium 32, 18A, single phase, supply voltage 115 to 230V, 0.5 to 1kW, IP20",
      bundles: [],
      driveVoltages: [
        {
          id: 193,
          outputVoltageMin: 100,
          outputVoltageMax: 120,
          outputVoltageMinMax: "100..120",
          toleranceMin: -15,
          toleranceMax: 10,
          nbPhases: "SINGLE_PHASE"
        },
        {
          id: 194,
          outputVoltageMin: 200,
          outputVoltageMax: 240,
          outputVoltageMinMax: "200..240",
          toleranceMin: -15,
          toleranceMax: 10,
          nbPhases: "SINGLE_PHASE"
        }
      ],
      driveCommunicationInterfaces: [
        {
          id: 189,
          communicationInterface: "CANMOTION",
          conditionOfUse: "INTEGRATED"
        },
        {
          id: 190,
          communicationInterface: "CANOPEN",
          conditionOfUse: "INTEGRATED"
        },
        {
          id: 191,
          communicationInterface: "MODBUS",
          conditionOfUse: "INTEGRATED"
        }
      ],
      driveOutputCurrents: [
        {
          id: 105,
          current: 6,
          frequency: 8
        }
      ]
    },
    gearbox: {
      commercialReference: "GBX060003K",
      family: "GBX",
      productOrComponentType: "PLANETARY_GEARBOX",
      type: "STRAIGHT_TEETH",
      efficiency: 96,
      reductionRatio: 3,
      maximumOutputTorque: 45,
      continuousOutputTorque: 28,
      shaftMomentOfInertia: 0.135,
      inputDiameter: 14,
      torsionalBacklash: 10,
      gearboxLength: 39,
      externalDiameter: 60,
      productWeight: 0.9,
      ipDegreeOfProtection: "IP54",
      description: "gearbox straight teeth GBX, Lexium, 60mm, reduction 3:1 , 10arc.min, 28N.m",
      bundles: []
    },
    adaptationKitRef: "GBK0600702F",
    adaptationKit: {
      commercialReference: "GBK0600702F",
      flangeSize: 70,
      weight: 0.2,
      compatibility: "LEXIUM_62_ILM",
      externalDiameter: 60,
      componentType: "adaptation kit",
      length: 16.1,
      accessoryDestination: "for assembly motor and gearbox",
      kitComposition: ["screws and bolts for mounting", "an adaptor plate", "a shaft end adaptor"],
      description: "adaptation kit, Lexium, GBK, size 60, 16mm, for assembly motor and gearbox",
      bundles: []
    },
    inertia: 6.5249999999999995,
    length: 177.1,
    supplyVoltage: 480,
    continuousOutputCurrent: 3,
    nominalTorque: 3.7439999999999998,
    nominalSpeed: 1666.6666666666667,
    nominalTorqueOfMotor: 1.3,
    nominalSpeedOfMotor: 5000
  }
];
